export const locale = {
  lang: 'it',
  data: {
    TITLE: 'Modifica documenti obbligatori',
    OTHER_DOC: {
      MANDATORY_DOC: 'Documenti obbligatori',
      LOAD_DOC: 'Caricare i seguenti documenti',
      MORE_DOC: 'Altri documenti obbligatori',
      OTHER_DOC: 'Altri documenti',
      INFO:
        'Completa la pratica allegando altri documenti che ritieni utili al fine di velocizzare l\'ammissione della fattura all\'asta\n' +
        '(es. contratto di fornitura, eventuale bolla di accompagnamento).',
      DELIVERY_NOTE: 'DDT firmato dal destinatario',
      DELIVERY_NOTE_CARRIER: 'DDT firmato dal vettore',
      CUSTOMER_ORDER: 'Ordine cliente',
      SUPPLY_CONTRACT: 'Contratto di fornitura',
      SDI_DELIVERY_RECEIPT: 'Ricevuta invio SDI',
      XML_INVOICE: 'Fattura elettronica in formato xml',
      XML_INVOICE_DOC: 'Fattura elettronica in formato xml',
      CLIENT_LEDGER: 'Partitario cliente',
      OTHER: 'Altro',
      CUSTOMER_ORDER_CONFIRMATION: 'Conferma ordine',
      WORK_PROGRESS: 'Sal - Stato avanzamento lavori',
      RELEASE_GUARANTEE_LETTER: 'Lettera di svincolo Factor',
      CUSTOMER_EMAIL_EXCHANGE: 'Scambio email con il cliente',
      PAYMENT_SLIP: 'Distinta di pagamento',
      DEBTOR_PLAFOND: 'Plafond Assicurazione - Debitore',
      CREDIT_INSURANCE: 'Beneficio polizza crediti',
      CREDIT_MANAGEMENT: 'Gestione del credito',
      CENTRAL_CREDIT_REGISTER: 'Centrale Rischi',
      INVOICE_CONFIRMATION: 'Conferma fattura',
      REGISTERED_MAIL: 'Raccomandata',
      ADD: 'Aggiungi',
      DELETE: 'Vuoi eliminare questo allegato?',
      NO: 'No',
      YES: 'Si',
      LABEL: {
        DELIVERY_NOTE: '# DDT',
        CUSTOMER_ORDER: '# Ordine',
        SUPPLY_CONTRACT: '# Contratto',
      },
    },
    ACTION: {
      CLOSE: 'Chiudi',
    },
    ERROR: {
      REQUIRED: 'Campo obbligatorio',
      INVALID: 'Valore invalido',
      EMAIL: 'Inserisci un\'email valida',
      TAX_CODE: {
        INVALID: 'C.F. invalido',
        FORMAT: 'Formato errato',
      },
      PHONE: 'Inserisci un numero di telefono valido',
      DATE: 'Inserisci una data valida',
      MINIMUM_BID_1: 'Il valore deve essere compreso tra',
      MINIMUM_BID_2: 'e',
      SELL_NOW:
        'Il valore deve essere compreso tra il valore minimo di vendita e l\'importo fattura',
      ATTACHMENT: 'Devi caricare almeno un allegato di categoria SDI e uno di un\'altra categoria',
      ATTACHMENT_UPLOAD: 'Errore nella modifica dell\'allegato',
    },
  },
};
